var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{attrs:{"loading":_vm.page_loading,"noPageMax":"1"}},[_c('div',{staticClass:"centered"},[_c('Breadcrumb',{attrs:{"crumbs":[
				{
					text : 'Home',
					to : {name:'templates'},
				},
				{
					text : 'Organisations',
					to : {name:'orgs'},
				} ]}}),_vm._v(" "),_c('UserPageNav'),_vm._v(" "),_c('h1',[_vm._v("Organisations you are part of")]),_vm._v(" "),_c('button',{staticClass:"btn-a",on:{"click":function($event){return _vm.addOrg()}}},[_vm._v("+ New organisation")]),_vm._v(" "),_c('div',{staticClass:"raised-box s-above"},[_c('List',{attrs:{"loading":_vm.loading,"results":_vm.orgs,"columns":[
					{
						label:'Name',
						name:'name',
						rowClick:true,
						text:function (v,r){ return r.name||'Personal projects'; },
						to: function (name,org){ return ({name:'org',params:{org_id:org.id}}); },
					},
					{
						label:'Status',
						name:'subscription',
						text:function (v,r){
							var sub = r.subscription;
							return sub.subscribed ? 'Subscription active' : (sub.trial_ends_at? 'Trial ends '+_vm.timeToExpiry(sub.trial_ends_at) : 'Trial expired');
						},
					} ]}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }